'use strict'
var _ = require('lodash')

var Marionette = require('marionette')
var App = require('app')

var Pikaday = require('pikaday')
var Moment = require('moment')
var DialogComponent = require('src/components/dialog-view')

/**
 * Dialog body view
 * -----------------------------------------------------------------------------
 * Body of the dialog
 */
var dialogBody = DialogComponent.Body.extend({
  template: require('./templates/control.html'),
  regions: {
    routineRegion: '.routine__region'
  },
  events: {
    'change .js-preset-select': 'onPresetChange'
  },
  onPresetChange: function (ev) {
    this.triggerMethod('dialog:load-preset', this, ev.currentTarget.value)
  },
  onRender: function () {
    var datePickerElStart = this.el.querySelector('.js-date-picker-start')
   // var datePickerElEnd = this.el.querySelector('.js-date-picker-end')

    var startDate = this.model.get('startDate')
  //  var endDate = this.model.get('endDate')

    var picker1 = new Pikaday({
      field: datePickerElStart,
      firstDay: 1,
      format: 'YYYY/MM/DD',
      minDate: Moment().subtract(1, 'days').toDate(),
      defaultDate: Moment(startDate).toDate(), // 14 Mar 2015
      setDefaultDate: true,
      // onSelect: function () {
      //   var date = this.getDate()
      //   var endDate = picker2.getDate()

      //   if (Moment(endDate).isBefore(date)) {
      //     picker2.setDate(date)
      //   }
      // }
    })

    // var picker2 = new Pikaday({
    //   field: datePickerElEnd,
    //   firstDay: 1,
    //   format: 'YYYY/MM/DD',
    //   minDate: Moment().subtract(1, 'days').toDate(),
    //   defaultDate: Moment(endDate).toDate(), // 14 Mar 2015
    //   setDefaultDate: true,
    //   onSelect: function () {
    //     // console.log(this.getMoment().format('Do MMMM YYYY'))
    //   }
    // })
  },
  templateContext: function () {
    var self = this
    return {
      getDeviceTypes: App.TemplateHelpers.getDeviceTypes,
      getSensorFieldName: App.TemplateHelpers.getSensorFieldName,
      getSensorAttribute: App.TemplateHelpers.getSensorAttribute,
      hasSensor: App.TemplateHelpers.hasSensor,
      getConditionalStr: App.TemplateHelpers.getConditionalStr,
      getSensorValue: App.TemplateHelpers.getSensorValue,
      getDeviceTypeLabel: App.TemplateHelpers.getDeviceTypeLabel,
      isSchedule: function () {
        return self.options.controlType === 'schedule'
      },
      getScheduleTypes: function () {
        var types = {
          'daily': 'Daily'
        }
        return types
      },
      getPresetList: function () {
        var deviceType = self.options.deviceType
        if (!self.options.client) return false
        var clientPresets = self.options.client.get('presets')
        if (!clientPresets) return false
        return _.filter(clientPresets, function (o) { return o.deviceType === deviceType && o.type === 'control' })
      }

    }
  }
})

/**
 * Dialog body view (Xw Driver)
 * -----------------------------------------------------------------------------
 *
 */
var dialogBodyXwDriver = dialogBody.extend({})

/**
 * Dialog body view (Ird Driver)
 * -----------------------------------------------------------------------------
 *
 */
var dialogBodyIrdDriver = dialogBody.extend({
  template: require('./templates/control-ird.html'),
  regions: {
    routineRegion_dali: '.routine__region'
  }
})

/**
 * Dialog body view (RTM IO)
 * -----------------------------------------------------------------------------
 *
 */
var dialogBodyRtmIoDriver = dialogBody.extend({
  template: require('./templates/control-rtm-io.html'),
  regions: {
    routineRegion_gpio: '.routine__region'
  }
})

/**
 * Dialog body view (Ird-Rgb Driver)
 * -----------------------------------------------------------------------------
 *
 */
var dialogBodyIrdRgbDriver = dialogBody.extend({
  template: require('./templates/control-ird-rgb.html'),
  regions: {
    routineRegion_dali: '.routine__region-dali',
    routineRegion_color: '.routine__region-color'
  }
})

/**
 * Dialog body view (Rgb Driver)
 * -----------------------------------------------------------------------------
 *
 */
var dialogBodyRgbDriver = dialogBody.extend({
  template: require('./templates/control-rgb.html'),
  regions: {
    routineRegion_color: '.routine__region'
  },
  events: {
    'change .js-preset-select': 'onPresetChange'
  }
})

module.exports.Body = dialogBody
module.exports.BodyXwDriver = dialogBodyIrdDriver
module.exports.BodyIrdDriver = dialogBodyIrdDriver
module.exports.BodyRgbDriver = dialogBodyRgbDriver
module.exports.BodyIrdRgbDriver = dialogBodyIrdRgbDriver
module.exports.BodyRtmIoDriver = dialogBodyRtmIoDriver

/**
 * Dialog view
 * -----------------------------------------------------------------------------
 * The dialog view
 */
var dialogView = DialogComponent.Layout.extend({
  className: 'dialog dialog-schedule',
  childViewTriggers: {
    'dialog:load-preset': 'dialog:load-preset'
  }
})

module.exports.Layout = dialogView



// WEBPACK FOOTER //
// ./js/modules/schedules/edit_new/view.js